import { render } from "./ActiveBox.vue?vue&type=template&id=605d45f5&scoped=true&ts=true"
import script from "./ActiveBox.vue?vue&type=script&lang=ts"
export * from "./ActiveBox.vue?vue&type=script&lang=ts"

import "./ActiveBox.vue?vue&type=style&index=0&id=605d45f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605d45f5"]])

export default __exports__